/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Execution_Modal_Asset_AltInputs */

const en_toast_execution_modal_asset_alt = /** @type {(inputs: Toast_Execution_Modal_Asset_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset`)
};

const de_toast_execution_modal_asset_alt = /** @type {(inputs: Toast_Execution_Modal_Asset_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anlage`)
};

const pt_br2_toast_execution_modal_asset_alt = /** @type {(inputs: Toast_Execution_Modal_Asset_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativo`)
};

const tr_toast_execution_modal_asset_alt = /** @type {(inputs: Toast_Execution_Modal_Asset_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varlık`)
};

const zh_cn2_toast_execution_modal_asset_alt = /** @type {(inputs: Toast_Execution_Modal_Asset_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`资产`)
};

const zh_hk2_toast_execution_modal_asset_alt = /** @type {(inputs: Toast_Execution_Modal_Asset_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`資產`)
};

const ko_kr2_toast_execution_modal_asset_alt = /** @type {(inputs: Toast_Execution_Modal_Asset_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자산`)
};

const ru_ru2_toast_execution_modal_asset_alt = /** @type {(inputs: Toast_Execution_Modal_Asset_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Актив`)
};

const es_419_toast_execution_modal_asset_alt = /** @type {(inputs: Toast_Execution_Modal_Asset_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activo`)
};

/**
* | output |
* | --- |
* | "Asset" |
*
* @param {Toast_Execution_Modal_Asset_AltInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const toast_execution_modal_asset_alt = /** @type {((inputs?: Toast_Execution_Modal_Asset_AltInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Execution_Modal_Asset_AltInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toast_execution_modal_asset_alt(inputs)
	if (locale === "de") return de_toast_execution_modal_asset_alt(inputs)
	if (locale === "pt-BR") return pt_br2_toast_execution_modal_asset_alt(inputs)
	if (locale === "tr") return tr_toast_execution_modal_asset_alt(inputs)
	if (locale === "zh-CN") return zh_cn2_toast_execution_modal_asset_alt(inputs)
	if (locale === "zh-HK") return zh_hk2_toast_execution_modal_asset_alt(inputs)
	if (locale === "ko-KR") return ko_kr2_toast_execution_modal_asset_alt(inputs)
	if (locale === "ru-RU") return ru_ru2_toast_execution_modal_asset_alt(inputs)
	return es_419_toast_execution_modal_asset_alt(inputs)
});